import endOfMonth from "date-fns/fp/endOfMonth";
import setMonth from "date-fns/fp/setMonth";
import setYear from "date-fns/fp/setYear";
import { compose } from "lodash/fp";

const getEndOfMonth = (month: number, year: number) =>
  compose(setYear(year), setMonth(month), endOfMonth)(new Date(0));

export default getEndOfMonth;
